import { AbstractDimension } from '@orus.eu/dimensions'
import { type NlRcphPricingFailure, type NlRcphQuote, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

export type NlRcphQuoteFailure = { type: 'missing-segment' } | { type: 'pricing-failure'; reason: NlRcphPricingFailure }

export type NlRcphQuoteResult = Result<NlRcphQuote, NlRcphQuoteFailure>

export class NlRcphQuoteDimension<NAME extends string> extends AbstractDimension<NAME, NlRcphQuoteResult> {
  override formatToString(value: NlRcphQuoteResult): string {
    if (value.type === 'failure') {
      return `NULL - ${value.problem.type}`
    }
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const nlRcphQuoteDimension = new NlRcphQuoteDimension({
  name: 'nlRcphQuote',
  displayKeys: { name: 'dimension_name_nl_rcph_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
